import React, { PureComponent } from 'react';
import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList,
} from 'recharts';


export class StackedChart extends PureComponent {

    buildData() {
        var data = [];
        var years = this.props.capital.length;
        var capital = this.props.capital;
        var profit = this.props.profit;

        for (var i = 0; i < years; i++) {
            var capitalCumulative = capital[i].value;
            var profitCumulative = profit;

            if (i !== 0) {
                capitalCumulative += data[i - 1]["Capital growth"];
                profitCumulative += data[i - 1]["Cumulative profit"];
            }

            var point = { Year: capital[i].year, "Capital growth": capitalCumulative, "Cumulative profit": profitCumulative };
            data.push(point);
        }
         
        return data;
    }

    render() {
        return (
            <ResponsiveContainer /*height={400}*/ width="100%">
                <BarChart
                    data={this.buildData()}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="Year"  />
                    <YAxis tickFormatter={(value) => (new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(value / 1000) + "k")}/>
                    {/*Fix highlighting on chart when there's no data*/}
                    {this.props.capital.length ? <Tooltip formatter={(value) => (new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(value / 1000) + "k")}/> : <Tooltip cursor={{ fill: 'transparent' }} /> }
                    <Legend />
                    <Bar dataKey="Capital growth" stackId="a" fill="#071D49" />
                    <Bar dataKey="Cumulative profit" stackId="a" fill="#00828c" >
                        {/*<LabelList position="top" formatter={(value) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(value)}/>*/}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/StackedChart.jsx